// solutionsAccordion JS, for collapsing accordion block in new theme

// solutionsAccordion JS, for collapsing accordion block in new theme
// datarobot6/views/gutenberg/content/dr-solutions-accordion.twig

document.addEventListener("DOMContentLoaded", () => {
	const accordions = document.querySelectorAll(".solutionsAccordion__accordion");

	accordions.forEach((accordion) => {
		const items = accordion.querySelectorAll(".solutionsAccordion__accordionItem");

		// Set the first accordion item to be open by default
		items.forEach((item, index) => {
			const content = item.querySelector(".solutionsAccordion__content");
			if (index === 0) {
				item.classList.add("-accordionOpen");
				content.style.maxHeight = content.scrollHeight + "px";
			} else {
				content.style.maxHeight = 0;
			}

			// Add click event listener to the toggle
			const toggle = item.querySelector(".solutionsAccordion__heading");
			toggle.addEventListener("click", () => {
				const isMobile = window.innerWidth < 768;

				if (isMobile) {
					// For mobile, toggle the current item independently
					toggleAccordionItem(item);
				} else {
					// For desktop, close all items except the one being clicked
					items.forEach((otherItem) => {
						if (otherItem !== item) {
							closeAccordionItem(otherItem);
						}
					});
					toggleAccordionItem(item);
				}
			});
		});
	});

	function toggleAccordionItem(item) {
		const content = item.querySelector(".solutionsAccordion__content");
		const isOpen = item.classList.contains("-accordionOpen");

		if (isOpen) {
			closeAccordionItem(item);
		} else {
			openAccordionItem(item);
		}
	}

	function openAccordionItem(item) {
		const content = item.querySelector(".solutionsAccordion__content");
		item.classList.add("-accordionOpen");
		content.style.maxHeight = content.scrollHeight + "px";
	}

	function closeAccordionItem(item) {
		const content = item.querySelector(".solutionsAccordion__content");
		item.classList.remove("-accordionOpen");
		content.style.maxHeight = 0;
	}

	// Update accordions on resize to handle mobile/desktop behavior
	window.addEventListener("resize", () => {
		accordions.forEach((accordion) => {
			const items = accordion.querySelectorAll(".solutionsAccordion__accordionItem");
			const isMobile = window.innerWidth < 768;

			items.forEach((item) => {
				const content = item.querySelector(".solutionsAccordion__content");
				if (isMobile) {
					// For mobile, keep current state
					if (item.classList.contains("-accordionOpen")) {
						content.style.maxHeight = content.scrollHeight + "px";
					}
				} else {
					// For desktop, ensure only one is open
					const openItem = Array.from(items).find((i) => i.classList.contains("-accordionOpen"));
					if (openItem && openItem !== item) {
						closeAccordionItem(item);
					} else if (item.classList.contains("-accordionOpen")) {
						content.style.maxHeight = content.scrollHeight + "px";
					}
				}
			});
		});
	});

	// console.log("accordion loading test");
});
